import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  toast,
} from "alm-react-components";
import { fetchUserAttributes, signIn } from "aws-amplify/auth";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import * as yup from "yup";
import { AppContext } from "../../context/AppProvider";
import {
  allStorage,
  authSession,
  awsErrorCodeMsgTosterOnLogin,
  clearLocalStorage,
  encrptText,
  errorTosterCodeMsg,
  getRedirectPaths,
  removeExitingSession
} from "../../lib/utils";
import SocialSignBtn from "../common/SocialSignBtn";

import {
  ActionType,
  APPROUTES,
  BackendRespose,
  CognitoResponse,
  constants,
  corporateKeys,
  CorporateUser,
  ParamMeters,
  ROUTES,
  StatusCode,
  SubscriptionStatus
} from "../../assets/constants/constants";
import { analytics_category, analytics_event, analytics_label, appcues_event } from '../../assets/constants/staticContentConstants';
import eye from "../../assets/images/eye.svg";
import eyeslash from "../../assets/images/eyeslash.svg";
import useGaEventTracking from "../../hooks/UseGaEventTracking";
import { apis } from "../../services/alm";

import {
  deviceDetails,
  getAlmToken,
  getSllUser,
  sendStorageToBakend,
  updateLanguageSetting
} from "../../services/user";
import { putAppCuesData } from "../../lib/appcues";

type Inputs = {
  username: string;
  password: string;
};

const CustomLogin = () => {
  const [revealed, setRevealed] = useState(false);
  const { state, dispatch } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const gaEventTracker = useGaEventTracking();
  const [query] = useSearchParams();
  const sessionExpire: any = query.get(ParamMeters.sessionExpire);

  useEffect(() => {
      // Remove exiting session when component unmounts
      sessionStorage.removeItem("lastActiveTimestamp");
      sessionStorage.removeItem("popupExpiryTimestamp");
      const checkUser= async() => {
      // Check if user is already logged in. If so, redirect to home page. Else, remove the existing session and clear the context.
      const accessToken = await authSession();
      if(accessToken !== undefined) {
        navigate(APPROUTES.home)
      }else{
        //Remove existing session when user logs out
        await clearLocalStorage(sessionExpire);
        dispatch({ type: ActionType.CLEAR_CONTEXT, payload: true });
      }

    }
    // Check user when component mounts or when session expires
    checkUser();
  }, []);
  // handle form submission and validation errors 
  async function onhandleSubmit(values: Inputs) {
    removeExitingSession();
    const params = {
      username: values.username.toLowerCase(),
      password: encrptText(values.password),
    };

    dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: true });
    await getSllUser(params.username).then(async (res: any) => {
      const headlessUserDetail = res.data;
      let loginActionFlag:boolean=true
      let errorTransition =''
      if(res.status == StatusCode.ERR_BAD_REQUEST){
        errorTransition =BackendRespose.userNotFoundError; 
        loginActionFlag=false
      }
      else if(res.status == StatusCode.SUCCESS && headlessUserDetail?.roles.includes(corporateKeys.LEARNER)){
        if( headlessUserDetail?.syncStatus== constants.EMAIL_UPDATED && params.username !==headlessUserDetail?.email){
          errorTransition=BackendRespose.userNotFoundError;
          loginActionFlag=false
        }
      }
      else if(res.status == StatusCode.SUCCESS && !headlessUserDetail?.roles.includes(corporateKeys.LEARNER )){
        if( headlessUserDetail?.corporateSubscriptionStatus == constants.INACTIVE ){
          errorTransition=BackendRespose.subscriptionExpired; 
          loginActionFlag=false
        }
        else if(headlessUserDetail?.corporateUserStatus === constants.DELETED) {
          errorTransition=BackendRespose.accountDeletedMessage;
          loginActionFlag=false
        } else if( headlessUserDetail?.corporateUserStatus !== constants.ACTIVE ){  
          errorTransition=BackendRespose.accountDeactivatedMessage;  
          loginActionFlag=false
        } 
       else  if(headlessUserDetail?.syncStatus== constants.EMAIL_UPDATED && params.username !==headlessUserDetail?.email){
        errorTransition=BackendRespose.userNotFoundError;
        loginActionFlag=false
        }
      } 
      if(loginActionFlag){
        loginAction(headlessUserDetail,params)
      }else{
        dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: false });
        errorTosterCodeMsg(errorTransition);
        return;
      }
    })
    .catch(() => {
      errorTosterCodeMsg(CognitoResponse.userNotFoundException);
      dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: false });
    });
  }
  const loginAction=(headlessUserDetail:any,params:any)=>{
      signIn(params)
      .then((res: any) => {
        if ( res.nextStep.signInStep === CognitoResponse.confirmSignWithPasswordRequired) {
          dispatch({ type: ActionType.CORPORATE_LOGIN, payload: params });
          navigate(APPROUTES.setupPassword)
        } else {
          // Navigate to home or dashboard
          doLogin(headlessUserDetail);
        }
      })
      .catch((error) => {
        const { message }: { name: any | undefined; message: any | undefined } = error;
        dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: false });
        awsErrorCodeMsgTosterOnLogin(message);
      });
  }
  const doLogin = async (headlessUserDetail:any) => {
    const accessToken = await authSession();
    localStorage.setItem("token", accessToken ? accessToken : "");
    fetchUserAttributes().then(async () => {
      //Set token
      const data = headlessUserDetail;
      const items = {
          value: null,
          currency: null,
          transaction_id: null,
          items: [{}],
          userId:data.userId,
          login_method:constants.Custom,
          device:constants.WEB
      };
        gaEventTracker(analytics_event.login,analytics_category.buttonCLickLogin,analytics_label.loginLabel,items);
        putAppCuesData({
          eventName:appcues_event.login,
          userId: data?.email,
          time_since_last_login: data?.lastLoggedIn,
          email:data?.email})
        dispatch({ type: ActionType.IS_AUTH, payload: true });
          if (data.roles.includes(corporateKeys.CORPORATE_OWNER) ) {
            setAccoutDataAndRedrection(corporateKeys.CORPORATE_OWNER,data.userStatus)
          }else if ( data.roles.includes(corporateKeys.CORPORATE_LEARNER)) {
            setAccoutDataAndRedrection(corporateKeys.CORPORATE_LEARNER,data.userStatus)
          } else {
            if (  data.subscriptionStatus === SubscriptionStatus.active || data.subscriptionStatus === SubscriptionStatus.trial ) {
              if (data.userStatus === constants.COMPLETED) {
                setAccoutDataAndRedrection(corporateKeys.LEARNER,data.userStatus)
              } else{ 
                dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: false });
                navigate(APPROUTES.profile);
              }
            } else if (
              data.subscriptionStatus === SubscriptionStatus.pending || data.subscriptionStatus === SubscriptionStatus.canceled || data.subscriptionStatus === SubscriptionStatus.trialOver
            ) {
              dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: false });
              if (data.subscriptionStatus === SubscriptionStatus.trialOver) {
                navigate(APPROUTES.selectCurrency);
              } else {
                navigate(APPROUTES.selectMembership);
              }
            }
          }
    });
  };

  const setAccoutDataAndRedrection = async(userType:string,userStatus:string)=>{
    const language = localStorage.getItem("locale") || constants.dutchLocale;
    const languageCode = localStorage.getItem("i18nextLng") || constants.dutchCode;
    await deviceDetails(constants.login);
    getAlmToken()
    .then(async (learnerRes: any) => {
      if (learnerRes.status === StatusCode.SUCCESS) {
        localStorage.setItem(
          "access_token",
          learnerRes.data.access_token
            ? learnerRes.data.access_token
            : ""
        ); 
        const now = new Date();
        localStorage.setItem('login_time', now.toISOString());
        await apis.checkAlmUser().then(async (res: any) => {
          dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: false });
          const userLanguage = res?.data?.attributes?.uiLocale;
          if (!userLanguage || userLanguage !== language) {
            localStorage.setItem('i18nextLng', languageCode);
            localStorage.setItem('locale', language);
            await apis.updateUserContent(
              learnerRes?.data?.user_id,
              language
            );
            await updateLanguageSetting(language);
            i18n.changeLanguage(languageCode);
          }
          if(userType === corporateKeys.CORPORATE_OWNER){
            await sendStorageToBakend(allStorage())
            window.open(`${corporateKeys?.CORPORATE_URL}?awsToken=${localStorage.getItem("token")}&language=${language}`, "_self");
          }else if(userType === corporateKeys.CORPORATE_LEARNER || userType === corporateKeys.LEARNER){
            if(userStatus === constants.COMPLETED ){
              navigate(APPROUTES.home);
            }else{
              navigate(APPROUTES.profile);
            }
          }else{
            if(userStatus === constants.COMPLETED ){
              navigate(APPROUTES.home);
            }else{
              navigate(APPROUTES.profile);
            }
          }
        });
      }else if( learnerRes.status === StatusCode.ERR_BAD_REQUEST){
        if(learnerRes.code===StatusCode.USER_NOT_PRESNT_IN_ALM){
          toast({
            description: t('Validations.userNotpresentinALM'),
            variant: 'error',
          });
        }
      }
      else {
        navigate("/");
      }
    })
    .catch(() => {
      dispatch({
        type: ActionType.LOTTIE_ANIMATION,
        payload: false,
      });
    });
  }
  //
  const schema = yup
    .object({
      username: yup
        .string()
        .required(t("Validations.emailRequired"))
        .matches(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          t("Validations.validEmail")
        ),
      password: yup.string().required(t("Validations.passwordRequired")),
    })
    .required();
  const form = useForm<Inputs>({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      username: "",
      password: "",
    },
  });
  return (
      <div className="md:min-w-[486px] md:max-w-[486px] px-4 md:mx-auto">
        <Card className="text-base border-0 bg-transparent">
          <CardHeader className="block px-0">
            <CardTitle
              className="text-4xl font-light font-barlowLight pb-11 text-center"
              dangerouslySetInnerHTML={{
                __html: t("LogIn.loginHeading"),
              }}
            />
          </CardHeader>
          <CardContent className="px-0">
            <SocialSignBtn />
            <Form {...form}>
              <FormMessage>{state.error && state.error.message}</FormMessage>
              <form onSubmit={form.handleSubmit(onhandleSubmit)} className="">
              {!CorporateUser && <div className="my-5 text-base text-center font-opensansSemiBold or-strip">
                <span className="px-4 py-2 dark:bg-black z-10 relative rounded-lg font-light"
                  dangerouslySetInnerHTML={{ __html: t("SignUp.or") }}
                />
              </div> }
                <div className="grid w-full items-center gap-4 mb-6">
                  <div className="flex flex-col space-y-1.5 text-base">
                    <FormField
                      control={form.control}
                      name="username"
                      render={({ field }) => (
                        <FormItem>
                          <FormLabel
                            className="font-opensansSemiBold text-xs tracking-wider"
                            dangerouslySetInnerHTML={{
                              __html: t("LogIn.emailAddress"),
                            }}
                          />

                          <FormControl>
                            <Input
                              placeholder={t("PlaceHolder.enterEmailAddress")}
                              {...field}
                              className="h-auto py-4 text-base opacity-100 text-white dark:text-white"
                            />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </div>
                  <div className="flex flex-col space-y-1.5 text-base">
                    <FormField
                      control={form.control}
                      name="password"
                      render={({ field }) => (
                        <FormItem className="relative">
                          <FormLabel className="font-opensansSemiBold text-xs tracking-wider">
                            {t("LogIn.password")}
                          </FormLabel>
                          <FormControl>
                            <Input
                              type={revealed ? "text" : "password"}
                              placeholder={t("PlaceHolder.entrPassword")}
                              {...field}
                              className="h-auto py-4 text-base pe-16 opacity-100 text-white dark:text-white"
                            />
                          </FormControl>
                          {revealed ? (
                              <img
                                className="absolute top-[45px] right-[16px] w-[26px] h-[16px]"
                                onClick={() => setRevealed(!revealed)}
                                src={eye}
                                alt="No image"
                              />
                          ) : (
                              <img
                                className="absolute top-[41px] right-[15px] w-[29px] h-[22px]"
                                onClick={() => setRevealed(!revealed)}
                                src={eyeslash}
                                alt="No image"
                              />
                          )}

                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </div>
                </div>
                <CardDescription className="text-slate-900 dark:text-white text-base font-light text-center mb-6">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: t("LogIn.termsOfService1"),
                    }}
                  />
                  <div className="flex flex-wrap justify-center py-1">
                    <a
                      href={ROUTES.TERMS}
                      className="underline pe-2"
                      onClick={(e:any) => {
                        e.preventDefault()
                        const redirectPaths = getRedirectPaths(
                          location,
                          "terms-of-services"
                        );
                        localStorage.setItem(
                          "redirectPaths",
                          JSON.stringify(redirectPaths)
                        );
                        navigate(ROUTES.TERMS);
                      }}
                    >
                      <span
                      className="tracking-wider"
                        dangerouslySetInnerHTML={{
                          __html: t("LogIn.termConditions"),
                        }}
                      />
                    ,
                    </a>
                    <a
                      href={ROUTES.PRIVACY}
                      className="underline  pe-2 "
                      onClick={(e:any) => {
                      e.preventDefault();
                      const redirectPaths = getRedirectPaths(
                          location,
                          "privacy-policy"
                        );
                        localStorage.setItem(
                          "redirectPaths",
                          JSON.stringify(redirectPaths)
                        );
                        navigate(ROUTES.PRIVACY);
                      }}
                    >
                     <span
                      className="tracking-wider"
                        dangerouslySetInnerHTML={{
                          __html: t("LogIn.privacyPolicy"),
                        }}
                      />,
                    </a>
                  <span className="pe-2">{t("LogIn.and")} </span>
                  <a
                    href={ROUTES.COOKIE}
                    className="underline"
                    onClick={(e: any) => {
                    e.preventDefault();
                      const redirectPaths = getRedirectPaths(
                        location,
                        "cookie-setting"
                      );
                      localStorage.setItem(
                        "redirectPaths",
                        JSON.stringify(redirectPaths)
                      );
                      navigate(ROUTES.COOKIE);
                    }}
                  >
                    <div
                      className="tracking-wider"
                      dangerouslySetInnerHTML={{
                        __html: t("LogIn.cookieSetting"),
                      }}
                    />
                  </a>
                  </div>
                </CardDescription>

                {form.formState.errors.username &&
                form.formState.errors.password ? (
                  <Button
                    disabled
                    className="w-full h-auto py-2 text-base mb-4 dark:bg-white truncate block"
                    dangerouslySetInnerHTML={{
                      __html: t("LogIn.loginHeading"),
                    }}
                  />
                ) : (
                  <Button
                    className="w-full h-auto py-2 text-base mb-4 truncate block"
                    dangerouslySetInnerHTML={{
                      __html: t("LogIn.loginHeading"),
                    }}
                  />
                )}
                <Button
                  onClick={() => navigate("/reset-password")}
                  variant={"link"}
                  className="h-auto block mx-auto py-2 px-0 text-base mb-6 underline dark:text-white"
                  dangerouslySetInnerHTML={{
                    __html: t("LogIn.resetPassword"),
                  }}
                />
              </form>
            </Form>
          </CardContent>
        </Card>
      </div>
  );
};

export default CustomLogin;
